import { PlateEditor, TText, Value } from '@udecode/plate-common';

import { ELEMENT_ANCHOR_LINK, MyAnchorLinkElement } from '../../../plateTypes';

export interface CreateAnchorLinkNodeOptions {
  linkId: string;
  text?: string;
  children?: TText[];
}

export const createAnchorLinkNode = <V extends Value>(
  editor: PlateEditor<V>,
  { linkId, text = '', children }: CreateAnchorLinkNodeOptions,
): MyAnchorLinkElement => {
  return {
    type: ELEMENT_ANCHOR_LINK,
    linkId,
    children: children ?? [{ text }],
  };
};
